// Status of a marketplace trade (a bid placed against an offer) as the admin
// Trades view shows it. Derived from the bid's MarketPlaceStatus and expiry,
// not stored:
//
// SETTLING: the bid is OPEN and its payment window is still running; its
//   volume is locked on the offer.
// SETTLED: the bid is PAID.
// EXPIRED: the payment window ran out before the bid was paid, whether or not
//   the bid has since been retired to CLOSED.
//
// Counter-offers awaiting approval and rejected counter-offers are not trades.
export var MarketPlaceTradeStatus;
(function (MarketPlaceTradeStatus) {
    MarketPlaceTradeStatus["SETTLING"] = "SETTLING";
    MarketPlaceTradeStatus["SETTLED"] = "SETTLED";
    MarketPlaceTradeStatus["EXPIRED"] = "EXPIRED";
})(MarketPlaceTradeStatus || (MarketPlaceTradeStatus = {}));
//# sourceMappingURL=MarketPlaceTradeStatus.js.map